module.exports = __webpack_public_path__ + "img/multi-device-sync-secondary.ffd04463.png";